import PodcastsPage from './PodcastsPage';

export {
    PodcastsPage,
}


// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/pages/index.js